import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {gameUiTexts} from 'data/ui-texts';
import {checkIfGroupHasCompletedTask, checkIfTaskIsLocked} from 'helpers/game-helper';
import {getGroupPoints} from 'helpers/game-helper';
import AreaButton from 'components/ui/area-button/area-button';
import Button from 'components/ui/button/button';
import Info from 'components/ui/info/info';
import Logo from 'components/ui/logo/logo';
import InfoBar from 'components/ui/info-bar/info-bar';
import Assignment from 'components/assignment/assignment';
import './case.scss';
import PopupAssignment from 'components/ui/popup-assignment/popup-assignment';
import appConfig from 'config/app.config';

const Case = (
	{ 
		schoolData,
		scenarioData,
		group, 
		groups, 
		infoTitle, 
		routes, 
		id, 
		casesId, 
		setCasesId, 
		updateGroup, 
		setPopupFileData, 
		setPageId
	}) => {
	/* Popup data for assignment popup */
	const [popupData, setPopupData] = useState(null);

	/* Selected task number */
	const [taskNumber, setTaskNumber] = useState(null);
	
	/* Group name and points */
	const groupName = group.name ? group.name : group.id;
	const groupPoints = getGroupPoints(group);
	
	/* Case title and text */
	const caseinfoTitle = routes.find((route) => {return route.id === casesId;})?.title;
	const caseinfoSubTitle = routes.find((route) => {return route.id === casesId;})?.subtitle;
	let caseinfoText = routes.find((route) => {return route.id === casesId;})?.text;
	if (schoolData) {
		caseinfoText = caseinfoText.replaceAll('%school%', schoolData.name);
	}
	const caseFiles = routes.find((route) => {return route.id === casesId;})?.files;

	/* All assignments in case */
	let caseTasksData = [];
	if (
		scenarioData.hasOwnProperty('tasksData') &&
		scenarioData.tasksData.hasOwnProperty(id) &&
		scenarioData.tasksData[id]
	) {
		caseTasksData = scenarioData.tasksData[id].filter((c) => {return c.caseId === casesId;});
	}

	return (
		<div className='Case'>
			{popupData &&
				<PopupAssignment 
					scenarioId={scenarioData.id}
					title={popupData.title}
					text={popupData.text}
					closePopup={() => {setPopupData(null);}}
				/>
			}
			<div className='Case-header'>
				<div className='Case-logo'><Logo scenarioId={scenarioData.id}/></div>
				<InfoBar points={groupPoints} iconId='trophy' scenarioId={scenarioData.id}/>
				<div className='Case-groupName'>
					<InfoBar text={groupName} iconId='person' scenarioId={scenarioData.id}/>
				</div>	
			</div>
			<div className='Case-contentWrapper'> 
				<div className='Case-sideWrapper'>
					<div className='Case-areaButton'>
						<AreaButton
							isSelected={true}
							areaButtonId={id}
							name={infoTitle} 
							scenarioId={scenarioData.id}
						/>
					</div>
					<div className='Case-assignments'>
						<div className='Case-title'>
							<span>{caseinfoTitle + (caseinfoSubTitle ? ':' : '')}</span>
							{caseinfoSubTitle && <span>{caseinfoSubTitle}</span>}
						</div>
						{taskNumber && 
							<div className={'Case-infoBtn ' + scenarioData.id} onClick={() => {setTaskNumber(null);}}/>
						}
						
						<div className='Case-cases'>
							{caseTasksData.map((task, index) => {
								const assignmentIsCompleted = checkIfGroupHasCompletedTask(task.taskId, group);
								const assignmentIsCurrent = task.taskNumber === taskNumber;
								const assignmentIsLocked = checkIfTaskIsLocked(task, group);

								let caseBtnClasses = ['assignment', scenarioData.id];
								if (assignmentIsCompleted) caseBtnClasses.push('completed');
								else if (assignmentIsCurrent) caseBtnClasses.push('current');
								else if (
									assignmentIsLocked && 
									appConfig.env !== 'development' && 
									appConfig.env !== 'test'
								) {
									caseBtnClasses.push('locked');
								}
								return (
									<div key={index} className='Case-casesButton'>
										{assignmentIsLocked && 
											<div className='Case-lockLine'/>
										}
										<div className='Case-button'>
											<Button
												isDisabled={
													assignmentIsLocked &&
													appConfig.env !== 'development' && 
													appConfig.env !== 'test'
												}
												classes={caseBtnClasses} 
												text={task.title}
												onClick={() => {setTaskNumber(task.taskNumber);}}
											/>
										</div>
									</div>
								);
							})}
						</div>
					</div>
					<div className="Case-backBtn">
						<Button 
							text={gameUiTexts.backBtn}
							classes={['backBtnGame', scenarioData.id, 'responsive']}
							onClick={() => {setCasesId(null);}}
						/>
					</div>
					
				</div>
				<div className='Case-middleWrapper'>
					{taskNumber ?
						<div className='Case-assignmentWrapper'>
							<Assignment 
								schoolData={schoolData}
								group={group} 
								groups={groups}
								scenarioData={scenarioData}
								areaId={id} 
								caseId={casesId} 
								caseTasksData={caseTasksData}
								taskNumber={taskNumber} 
								updateGroup={updateGroup}
								setPopupFileData={setPopupFileData}
								setPopupData={setPopupData}
								setTaskNumber={setTaskNumber}
								setPageId={setPageId}
								setCasesId={setCasesId}
							/>
						</div>
						:
						<div className='Case-infoWindow'>
							<Info 
								title={caseinfoTitle + ':'}
								subtitle={caseinfoSubTitle}
								text={caseinfoText}
								files={caseFiles}
								setPopupFileData={setPopupFileData}
								scenarioId={scenarioData.id}
							/>
						</div>
					}
				</div>
			</div>
		</div>
	);
};

Case.propTypes = {
	schoolData: PropTypes.object.isRequired,
	scenarioData: PropTypes.object.isRequired,
	infoTitle: PropTypes.string.isRequired,
	routes: PropTypes.array.isRequired,
	id: PropTypes.string.isRequired,
	casesId: PropTypes.number.isRequired,
	setCasesId: PropTypes.func.isRequired,
	group: PropTypes.object.isRequired,
	groups: PropTypes.array.isRequired,
	updateGroup: PropTypes.func.isRequired,
	setPopupFileData: PropTypes.func.isRequired,
	setPageId: PropTypes.func.isRequired,
};

export default Case;